import { api } from "./api";

// ---- Public fetch helpers ----
export const fetchCurrentWord = () =>
  api.get("/word-of-week/current").then((r) => r.data).catch(() => null);
export const fetchDictionary = (params = {}) =>
  api.get("/word-of-week/dictionary", { params }).then((r) => r.data).catch(() => null);
export const fetchWord = (slug) =>
  api.get(`/word-of-week/${slug}`).then((r) => r.data?.word).catch(() => null);

// ---- Child progress sync (signed-in). action: read | listen | favorite | practice | save ----
export const syncWord = (childId, payload) =>
  api.post(`/children/${childId}/word`, payload).then((r) => r.data).catch(() => null);

// ---- Guest fallback (localStorage) so the lifelong collection works for everyone ----
const KEY = "gk_word_learning";
const readLS = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
};
const writeLS = (m) => { try { localStorage.setItem(KEY, JSON.stringify(m)); } catch { /* ignore */ } };

export const getGuestWordState = (slug) => readLS()[slug] || {};
export const setGuestWord = (slug, action, value = true) => {
  const m = readLS();
  const e = m[slug] || { read: false, listened: false, favorite: false, practiced: false, saved: false };
  if (action === "read") e.read = true;
  else if (action === "listen") e.listened = true;
  else if (action === "favorite") e.favorite = value;
  else if (action === "save") e.saved = value;
  else if (action === "practice") e.practiced = true;
  m[slug] = e;
  writeLS(m);
  return e;
};
export const getGuestSaved = () => {
  const m = readLS();
  return Object.keys(m).filter((s) => m[s].saved);
};

// Browser TTS narration — free, no assets. Returns true if speech started.
export const speakText = (text) => {
  try {
    if (!("speechSynthesis" in window) || !text) return false;
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.rate = 0.92; u.pitch = 1.05;
    window.speechSynthesis.speak(u);
    return true;
  } catch { return false; }
};
